<template>
  <div class="change-position-mobile">
    <el-row class="section-name-block add-type">
      <img
        src="@/assets/images/type.png"
        class="image-col mobile-version-filter"
        alt="rooms"
      />
      <h3 class="section-name">тип нерухомості :</h3>
    </el-row>
    <el-row class="check-buttons-list add-type">
      <CheckBtn
        v-for="(btn, index) in displayList"
        @change="filterHandlerArray($event)"
        :key="index"
        :data="btn"
      />
    </el-row>
  </div>
</template>

<script>
import CheckBtn from '@/components/common/CheckBtn'
import { filterMixin } from '@/helper/mixins'
export default {
  name: 'Types',
  components: { CheckBtn },
  mixins: [filterMixin],
}
</script>

<style scoped></style>
